import React from 'react';
import { TextWork } from './Editor/Editor';
import './Work.css';

function Work() {
  
  return (
      <React.Fragment>
            <div className="work-station-container">
                <TextWork />
            </div>
      </React.Fragment>
  );
}

export { Work };